/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';


const mock = [
  
  // {
    
  //   description:
  //     'Eco Association Class 1',
  //   href : '/art-leaf-2024'
 
  // },
  // {
    
  //   description:
  //     'Eco Association Class 2',
  //   href : '/planting-seeds-2024'
 
  // },
  // {
    
  //   description:
  //     'Eco Association Class 3-5',
  //   href : '/eco-club-class-3to5-2024'
 
  // },
  {
    
    description:
      'Eco Association Class 6',
    href : '/eco-club-class4-2024'
 
  },
  {
    
    description:
      'Eco Association Class 7 & 8',
    href : '/eco-club-class7-8-2024'
 
  },
  {
    
    description:
      'Eco Association Class 9 & 10',
    href : '/voice-for-change-2024'
 
  },
  {
    
    description:
      'Eco Association Class 11 & 12',
    href : '/trash-into-triumph-2024'
 
  },
  // {
    
  //   description:
  //     'Environment Day Celebration',
  //   href : '/environment-day-2024'
 
  // },

  

];

const EcoAssociationSidebar2024 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Eco Association 2024-25
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'P'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
     
    </Box>

  );
};

export default EcoAssociationSidebar2024;
